import { Component, ErrorInfo, ReactNode } from "react";

interface Props {
    children: ReactNode;
}

interface State {
    hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(): State {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
        // eslint-disable-next-line no-console
        console.error("ErrorBoundary caught an error:", error, errorInfo);
    }

    handleReload = (): void => {
        window.location.reload();
    };

    render(): ReactNode {
        if (this.state.hasError) {
            return (
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        minHeight: "100vh",
                        fontFamily: "sans-serif",
                        textAlign: "center",
                        padding: "2rem",
                    }}
                >
                    <h2 style={{ marginBottom: "1rem", fontSize: "1.5rem", color: "#333" }}>
                        Algo sali&oacute; mal
                    </h2>
                    <p style={{ marginBottom: "1.5rem", fontSize: "1rem", color: "#666" }}>
                        Por favor, recarg&aacute; la p&aacute;gina.
                    </p>
                    <button
                        onClick={this.handleReload}
                        style={{
                            padding: "0.75rem 2rem",
                            fontSize: "1rem",
                            backgroundColor: "#1a73e8",
                            color: "#fff",
                            border: "none",
                            borderRadius: "8px",
                            cursor: "pointer",
                        }}
                    >
                        Recargar
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
